module.exports = __webpack_public_path__ + "img/lib_region_flag_rs.5bf7b289.png";